import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { CssBaseline, ThemeProvider } from '@mui/material';

import { theme } from '../theme';
import { Reporti18nInstance } from '../i18n/configs';
import { AxiosClientProvider } from '../services/store/AxiosClient';

export function Providers({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <>
      <CssBaseline />
      <I18nextProvider i18n={Reporti18nInstance}>
        <ThemeProvider theme={theme}>
          <AxiosClientProvider
            axiosConfig={{
              baseURL:
                process.env.REACT_APP_BACKEND_BASE_URL ||
                'https://api.dev.rpt.rvstacor.jp',
              timeout: parseInt(
                process.env.REACT_APP_CONNECTION_TIMEOUT || '60000'
              ),
            }}
            setAuthorizationBeforeRequest={{}}
            setTraceParentBeforeRequest={{}}
          >
            {children}
          </AxiosClientProvider>
        </ThemeProvider>
      </I18nextProvider>
    </>
  );
}
